
export class PasswordStat {
    score: number;
    crack_time_display: string;
    cack_time: number;
}

export class PasswordStats {
    password: PasswordStat;
}